import styled, { ThemeProvider } from 'styled-components';
import { css } from '@styled-system/css';

import { retirementGlossaryTermProps } from 'humanity/pages/retirementGlossaryTerm/retirementGlossaryTerm.types.js';
import Container from 'humanity/primitives/container';
import CtaBanner from 'humanity/sections/ctaBanner';
import SimpleRichTextSection from 'humanity/sections/simpleRichTextSection';
import { theme } from 'utils/theme.v2';
import Link from 'humanity/primitives/link';
import { RETIREMENT_GLOSSARY_SLUG } from 'pages/learn/retirement-glossary';
import TextContainer from 'humanity/components/textContainer';
import Dripicon from 'humanity/components/dripicon';
import Heading from 'humanity/primitives/heading';
import { LcRelatedArticles } from 'humanity/sections/lcRelatedArticles';

const StyledBackLink = styled(Link)(
  css({ display: 'flex', alignItems: 'center', mb: 4 })
);

const RetirementGlossaryTerm = ({ title, sections }) => (
  <Container py={7}>
    <ThemeProvider theme={theme}>
      <TextContainer>
        <StyledBackLink href={`/${RETIREMENT_GLOSSARY_SLUG}`}>
          <Dripicon icon="ChevronLeft" /> Back to Glossary
        </StyledBackLink>
        <Heading variant="h1" as="h1">
          {title}
        </Heading>
      </TextContainer>
      {sections.map((section) => {
        switch (section.__typename) {
          case 'SimpleRichTextSection':
            return <SimpleRichTextSection {...section} />;
          case 'CtaBanner':
            return <CtaBanner {...section} />;
          case 'SectionLearningCenterRelatedArticles':
            return (
              <LcRelatedArticles
                title={section.title}
                articles={section.articlesCollection.items}
              />
            );
          default:
            return null;
        }
      })}
    </ThemeProvider>
  </Container>
);

RetirementGlossaryTerm.propTypes = {
  ...retirementGlossaryTermProps,
};

export default RetirementGlossaryTerm;
